// UserProducts.jsx
import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout/Layout";
import { elakay_API, toImageUrl } from "../../config";
import { getUserProducts, getProductsF } from "../auth/apiProduct";
import Card from "../pageInside/Card";
import { Row } from "react-bootstrap";
import { saveSettings, loadSettings } from "../auth";
import { isAuthenticated } from "../auth";
import MyProductDeal from "../pageInside/userProductDeal";
import AddPubGloabal from "../pageInside/addPubGloabal";
import PubShop from "../pageInside/addPubShop";
import { MdPrint } from "react-icons/md";
import Printer from "../pageInside/printerMyshop";
import Modal from "react-bootstrap/Modal";
import ButtonPagination from "../pageInside/ButtonPagination";
import { laguangeElakay, getElakayLanguageContext } from "../pageInside/dataElakay";
import ShopUserView from "./lakayUser/ShopUser";
import { prices } from "../pageInside/fixedPrices";
import { Family, canViewDropshippingSellerCenter, getCommercialCapabilities } from "../pageInside/Rolle";
import nodata from "../Layout/imgs/nodata0.png";
import Orders from "./buyerOrder";
import Sell from "../pages/addProduct";
import FilterUserTeam from "../pageInside/filterUserTeam";
import FilterUserProduct from "../pageInside/filterUserProduct";
import SearchBar from "../pageInside/admin_associate_searchBar";
import PaginationInfo from "../pageInside/paginationInfo";
import { decryptData } from "../auth/elakayCryptage";
import PriProductTable from "../pageInside/PriProductTable";
import CardTable from "../pageInside/cardTable.jsx";
import SellingHubButtons from "../pageInside/SellingHubButtons.jsx";
import "./UserProducts.css";
import { elakayAutoText } from "../pageInside/dataElakay";
import { useMyShopNavigation, useSellCenterSelection } from "./myShopNavigation";
import { activeShopOf, useAccountShops, useActiveShopChange } from "../shops/accountShopsStore";
import ShopBar from "../shops/ShopBar";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["userProduct"]?.[key] || fallback;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const UserProducts = (props) => {
  const { infoSource } = props;
  __setElakayInfoSource(infoSource);

  const { userInfo } = infoSource;
  const location = useLocation();
  const query = useQuery();
  const [settings, setSettings] = useState(loadSettings());
  const { tab: activeTab, view: activeView, section: activeSection, setMyShopQuery, changeView, changeSection } = useMyShopNavigation();
  const { selectedSellType, setSelectedSellType, sellSessionKey } = useSellCenterSelection(activeTab);

  const filterlist = {
    asc: "asc",
    unpublished: false,
    dropshipping: false,
    limit: 12,
    sortBy: "createdAt",
    search: "",
  };

  const shopAllProdB = [activeView === "admin", activeView === "customer", activeView === "orders"];
  const DealProduct = activeTab === "deal" ? (activeView === "in" ? 1 : 0) : 3;
  const [showTrash, setShowTrash] = useState(() => query.get("trash") === "1");

  const [showFilterOurTeam, setSowFilterOurTeam] = useState(false);
  const [getFilterUserProd, setFilterUserProd] = useState(filterlist);

  // Every view of this page (products, Customer View, orders) shows the
  // Seller boutique being managed; switching boutique reloads them.
  const { data: accountShops } = useAccountShops();
  const activeSellerShop = activeShopOf(accountShops, "seller");
  const activeSellerShopKey = activeSellerShop?._id || "no-shop";
  const activeSellerShopId = activeSellerShop?._id || null;
  useActiveShopChange("seller", React.useCallback(() => {
    setFilterUserProd((current) => ({ ...current }));
  }, []));

  const divCatProduct = useRef(null);
  const scrollToParagraph = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const { asc, limit, unpublished, dropshipping, sortBy, search } = getFilterUserProd;

  const productShowAll = activeTab === "products" && !showTrash;
  const sellAddProdBoll = activeTab === "sell-center";
  const productShowDealTrue = activeTab === "deal" && activeView === "in";
  const productShowDealFalse = activeTab === "deal" && activeView === "out";
  const userAddPubShow = activeTab === "pub";

  const [productsByArrival, setProductsByArrival] = useState([]);
  const [productLoadError, setProductLoadError] = useState("");
  const [skip, setSkip] = useState(0);
  const [size, setSize] = useState(0);
  const [siseProduct, setSiseProduct] = useState(0);
  const [getCategoriesUser, setCategoriesUser] = useState([]);

  const shopPubB = activeView === "global";
  const [showOrderView, setShowOrderView] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showSideDeal, setShowSideDeal] = useState(false);
  const [showListeShop, setShowListeShop] = useState(false);
  const [productaddToDeal, setProductaddToDeal] = useState([]);

  const { token } = isAuthenticated();
  const [categories, setCategories] = useState([]);
  const [categoryID, setCategoryID] = useState(["null"]);
  const [text, setText] = useState();
  const [filterShop, setFilterShop] = useState(false);
  const [getCalFilShop, setCalFilShop] = useState([]);
  const [pageShop, setPageShop] = useState(false);

  const [myFilters, setMyFilters] = useState({
    filters: { "categoriesID.gategoriesLink": [] },
  });

  const filterUrl = { search: search || undefined, category: categoryID };

  useEffect(() => {
    setShowTrash(query.get("trash") === "1");
    loadProductsByArrival(token, DealProduct, myFilters, getFilterUserProd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, DealProduct, location.search, myFilters, search, getFilterUserProd, showTrash]);

  // Un clic répété sur le bouton flottant doit rouvrir/recharger la corbeille
  // même si l'URL est déjà /myShop?trash=1 (React Router ne change alors pas
  // location.search et aucun effet de navigation ne serait normalement émis).
  useEffect(() => {
    const openTrash = () => {
      setShowTrash(true);
      setFilterUserProd((current) => ({ ...current }));
    };
    window.addEventListener("elakay:open-trash", openTrash);
    return () => window.removeEventListener("elakay:open-trash", openTrash);
  }, []);

  const loadProductsByArrival = (token, DealProduct, myFilters, getFilterUserProd) => {
    setProductLoadError("");
    getUserProducts(token, skip, limit, { ...getFilterUserProd, trash: showTrash }, DealProduct, filterUrl, myFilters.filters).then((data) => {
      if (!data || data.error) {
        setProductsByArrival([]);
        setSiseProduct(0);
        setSize(0);
        setProductLoadError(data?.error || __elakayText("loadError", "Unable to load products."));
        setLoading(false);
      } else {
        // Défense supplémentaire côté UI : même si une ancienne API ignore
        // accidentellement ?trash=true, aucun produit actif ne peut entrer
        // dans la vue Corbeille.
        setProductsByArrival(showTrash
          ? (data.products || []).filter((product) => product?.isDeleted === true)
          : (data.products || []));
        setSiseProduct(data.siseProduct);
        setSize(data.size);
        setSkip(0);
        setShowSideDeal(false);
        setLoading(false);
        getCategoriesUser?.length == 0 && setCategoriesUser(data.categories);
      }
    });
  };

  const loadMore = () => {
    let toSkip = skip + limit;

    scrollToParagraph(divCatProduct);
    getUserProducts(token, toSkip, limit, { sortBy, asc, unpublished, dropshipping, trash: showTrash }, DealProduct, filterUrl, myFilters.filters).then(
      (data) => {
        if (!data || data.error) {
          setProductLoadError(data?.error || __elakayText("loadError", "Unable to load products."));
        } else {
          setProductLoadError("");
          setProductsByArrival(showTrash
            ? (data.products || []).filter((product) => product?.isDeleted === true)
            : (data.products || []));
          setSiseProduct(data.siseProduct);
          setSize(data.size);
          setSkip(toSkip);
        }
      }
    );
  };

  const loadMore0 = () => {
    let toSkip = skip - limit;
    scrollToParagraph(divCatProduct);
    getUserProducts(token, toSkip, limit, { sortBy, asc, unpublished, dropshipping, trash: showTrash }, DealProduct, filterUrl, myFilters.filters).then(
      (data) => {
        if (!data || data.error) {
          setProductLoadError(data?.error || __elakayText("loadError", "Unable to load products."));
        } else {
          setProductLoadError("");
          setProductsByArrival(showTrash
            ? (data.products || []).filter((product) => product?.isDeleted === true)
            : (data.products || []));
          setSiseProduct(data.siseProduct);
          setSize(data.size);
          setSkip(toSkip);
        }
      }
    );
  };

  const ButtonShoAllProduct = () => {
    setShowTrash(false);
    setMyShopQuery({ tab: "products", view: "admin", section: null, trash: null });
  };

  const ButtonsellAddProd = () => {
    setShowTrash(false);
    setSelectedSellType(null);
    setMyShopQuery({ tab: "sell-center", view: null, section: null, trash: null, ip: null, ic: null });
  };

  const ButtonDealProduct = () => {
    setShowTrash(false);
    setMyShopQuery({ tab: "deal", view: "in", section: null, trash: null });
  };

  const ButtonNotDealProduct = () => {
    setShowTrash(false);
    changeView("out");
  };

  const ButtonNotUserPub = () => {
    setShowTrash(false);
    setMyShopQuery({ tab: "pub", view: "global", section: null, trash: null });
  };

  const handlePrice = (value) => {
    // Slider "Customer price" → déjà un [min, max] numérique, pas un _id de palier.
    if (Array.isArray(value)) return value;
    let array = [];
    for (let key in prices) {
      if (prices[key]._id === parseInt(value)) {
        array = prices[key].array;
      }
    }
    return array;
  };

  const handleFilters = (filters, filterBy) => {
    const newFilters = { ...myFilters };
    newFilters.filters[filterBy] = filters;

    if (filterBy === "price") {
      let priceValues = handlePrice(filters);
      newFilters.filters[filterBy] = priceValues;
    }

    setMyFilters(newFilters);
  };

  const myDealtrue = () =>
    !productShowDealTrue ? (
      <button
        className="btn btn-md btn-primary float-right p-1"
        style={{ fontSize: "9px" }}
        onClick={ButtonDealProduct}
      >
        {infoSource.laguangeElakay("Button", infoSource.languageAPI).mydeal}
      </button>
    ) : (
      <button className="btn btn-md  float-right p-1" style={{ fontSize: "9px" }}>{__elakayText("t003", "My deal")}</button>
    );

  const myDealfalse = () =>
    !productShowDealFalse ? (
      <button
        className="btn btn-md btn-primary float-right p-1"
        style={{ fontSize: "9px" }}
        onClick={ButtonNotDealProduct}
      >
        {infoSource.laguangeElakay("Button", infoSource.languageAPI).notindeal}
      </button>
    ) : (
      <button className="btn btn-md  float-right p-1" style={{ fontSize: "9px" }}>{__elakayText("t004", "not in deal")}</button>
    );

  const myDealAll = () =>
    !productShowAll ? (
      <button
        className="btn btn-md btn-primary float-right p-1"
        style={{ fontSize: "9px" }}
        onClick={ButtonShoAllProduct}
      >
        {infoSource.laguangeElakay("Button", infoSource.languageAPI).allProduct}
      </button>
    ) : (
      <button className="btn btn-md  float-right p-1" style={{ fontSize: "9px" }}>{__elakayText("t005", "All Product")}</button>
    );

  const AddDeal = () =>
    !userAddPubShow ? (
      <button
        className="btn btn-md btn-primary float-right p-1"
        style={{ fontSize: "9px" }}
        onClick={ButtonNotUserPub}
      >
        {infoSource.laguangeElakay("Button", infoSource.languageAPI).creataPub}
      </button>
    ) : (
      <button className="btn btn-md  float-right p-1" style={{ fontSize: "9px" }}>{__elakayText("t006", "Creat a Pub")}</button>
    );

  const ButtonMyShop = () => (
    <nav className="row">
      <h1 className="mb-3">{AddDeal()}</h1>
      <h1 className="mb-3">{myDealAll()}</h1>
      <h1 className="mb-3">{myDealfalse()}</h1>
      <h1 className="mb-3">{myDealtrue()}</h1>
    </nav>
  );

  const productALL = (
    <div>
      <PaginationInfo
        skip={skip}
        limit={limit}
        siseProduct={siseProduct}
        infoSource={infoSource}
        prodCat={infoSource.language(infoSource, "headNenu", "myShop")}
      />

      {settings.SPT ? (
        <div className="contaire">
          <CardTable
            infoSource={infoSource}
            myShop={productsByArrival}
            setProductaddToDeal={setProductaddToDeal}
            loadProductsByArrival={loadProductsByArrival}
            setShowSideDeal={setShowSideDeal}
            DealProduct={DealProduct}
            showSideDeal={showSideDeal}
            myFilters={myFilters}
            getFilterUserProd={getFilterUserProd}
            trashMode={showTrash}
          />
        </div>
      ) : (
        <Row className="m-1" xs={2} sm={2} md={3} lg={4}>
          {productsByArrival &&
            productsByArrival?.map((product, i) => (
              <div className="col p-2" key={i}>
                <Card
                  laguangeElakay={laguangeElakay}
                  infoSource={infoSource}
                  classCard0="col p-0"
                  loadProductsByArrival={loadProductsByArrival}
                  product={product}
                  myFilters={myFilters}
                  getFilterUserProd={getFilterUserProd}
                  showAddToCartButton={false}
                  showButtonUser={true}
                  setProductaddToDeal={setProductaddToDeal}
                  setShowSideDeal={setShowSideDeal}
                  showSideDeal={showSideDeal}
                  CataID={product?.categoriesID?.length > 0 ? product.categoriesID[0].catID : undefined}
                  showShopV={false}
                  trashMode={showTrash}
                  skip={skip}
                  limit={limit}
                />
              </div>
            ))}
        </Row>
      )}
    </div>
  );

  const resultPagination = (
    <div>
      <div>
        {parseInt(skip) - parseInt(limit) + parseInt(limit) + 1} -{" "}
        {parseInt(skip) + parseInt(limit) > siseProduct ? siseProduct : parseInt(skip) + parseInt(limit)}{" "}
        {infoSource.language(infoSource, "label", "of")} {siseProduct}{" "}
        {infoSource.laguangeElakay("label", infoSource.languageAPI).items}
      </div>
    </div>
  );

  const showAllProduct = () =>
    productShowAll && (
      <div>
        <div className="h3">
          <MdPrint onClick={() => setShowListeShop(true)} />
        </div>
        {productLoadError && <div className="alert alert-danger" role="alert">{productLoadError}</div>}
        {filterCategory()}
        {productALL}
        <ButtonPagination
          laguangeElakay={laguangeElakay}
          infoSource={infoSource}
          size={size}
          skip={skip}
          limit={limit}
          siseProduct={siseProduct}
          loadMore={loadMore}
          loadMore0={loadMore0}
        />
      </div>
    );

  const showTrashProduct = () =>
    showTrash && (
      <div>
        {productALL}
        <ButtonPagination
          laguangeElakay={laguangeElakay}
          infoSource={infoSource}
          size={size}
          skip={skip}
          limit={limit}
          siseProduct={siseProduct}
          loadMore={loadMore}
          loadMore0={loadMore0}
        />
      </div>
    );

  const showDealProduct = () =>
    productShowDealTrue && (
      <MyProductDeal
        laguangeElakay={laguangeElakay}
        infoSource={infoSource}
        DealProduct={DealProduct}
        setProductaddToDeal={setProductaddToDeal}
        setShowSideDeal={setShowSideDeal}
        showSideDeal={showSideDeal}
        productsByArrival={productsByArrival}
        loadProductsByArrival={loadProductsByArrival}
        loadM={loadMore}
        loadM0={loadMore0}
        siseProduct={siseProduct}
        filterCategory={filterCategory}
        categoryID={categoryID}
        titte={infoSource.language(infoSource, "menuSertting", "yourProInDeal")}
        text={text}
        size={size}
        skip={skip}
        limit={limit}
      />
    );

const sellerAddProd = () => {
  if (!sellAddProdBoll) return null;
  const canSeeDropshipping = canViewDropshippingSellerCenter(infoSource);
  const hiddenDropshippingSelection = !canSeeDropshipping && ['dropshippingIn', 'dropshippingOut'].includes(selectedSellType);
  // Ticket "CORRECTION ROLE PROVIDER / SELLER" §5/§6 -- Provider est
  // au-dessus de Seller (hérite de My Shop/Sell Center) mais ne doit jamais
  // atteindre le formulaire Seller classique (Sell Your Product), même via
  // un état `selectedSellType` déjà positionné (ex. deep-link, état restauré
  // après un refresh) -- SellingHubButtons cache déjà la carte elle-même,
  // ceci protège le rendu direct ; le backend (POST /products/create) reste
  // la vraie barrière.
  const isProviderRole = !getCommercialCapabilities(infoSource).canCreateSellerProduct;
  const hiddenSellProductSelection = isProviderRole && selectedSellType === 'sellProduct';

  return (
    <div>
      {/* La page choisie s'affiche directement au clic sur un bouton du hub. */}
      {selectedSellType === 'sellProduct' && !isProviderRole && (
        <Sell
          key={sellSessionKey}
          infoSource={infoSource}
          onBack={() => {
            setSelectedSellType(null);
            setMyShopQuery({ ip: null, ic: null });
          }}
        />
      )}

      {/* Si pas encore de choix validé, on affiche le hub */}
      {(!selectedSellType || hiddenDropshippingSelection || hiddenSellProductSelection) && (
        <SellingHubButtons
          infoSource={infoSource}
          onNavigate={setSelectedSellType}
        />
      )}
    </div>
  );
};

  const showNotDealProduct = () =>
    productShowDealFalse && (
      <MyProductDeal
        laguangeElakay={laguangeElakay}
        infoSource={infoSource}
        DealProduct={DealProduct}
        setProductaddToDeal={setProductaddToDeal}
        setShowSideDeal={setShowSideDeal}
        showSideDeal={showSideDeal}
        productsByArrival={productsByArrival}
        loadProductsByArrival={loadProductsByArrival}
        loadM={loadMore}
        loadM0={loadMore0}
        siseProduct={siseProduct}
        filterCategory={filterCategory}
        categoryID={categoryID}
        titte={infoSource.language(infoSource, "menuSertting", "yourProOutDeal")}
        text={text}
        size={size}
        skip={skip}
        limit={limit}
      />
    );

  const showUserPubPage = () =>
    userAddPubShow &&
    shopPubB &&
    (Family(userInfo.email) ? (
      <>
        <AddPubGloabal laguangeElakay={laguangeElakay} infoSource={infoSource} />
      </>
    ) : (
      <div>
        <div className="row mt-4 mb-4 justify-content-center">
          <img className="shadow-lg" style={{ width: "100%" }} src={nodata} alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).userProduct.t001} />
        </div>
      </div>
    ));

  const showUserPubShop = () =>
    userAddPubShow &&
    !shopPubB && (
      <PubShop
        laguangeElakay={laguangeElakay}
        infoSource={infoSource}
        userID={userInfo._id}
        activeSection={activeSection}
        onSectionChange={changeSection}
      />
    );

  const printListeShop = () => (
    <div className="contaire">
      <div className="row justify-content-center ">
        <Modal
          size="xl"
          show={showListeShop}
          onHide={() => setShowListeShop(false)}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              {infoSource.laguangeElakay("title", infoSource.languageAPI).UserViewdListeShop}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                overflow: "scroll",
              }}
            >
              <Printer laguangeElakay={laguangeElakay} infoSource={infoSource} MyShop={productsByArrival} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );

  const toggleSPT = () => {
    const newSettings = { ...settings, SPT: !settings.SPT };
    setSettings(newSettings);
    saveSettings(newSettings);
  };

  const handleChange = () => (event) => {
    const value = event.target.value;

    if (value === null || value === undefined) {
      setCategoryID();
    } else {
      setCategoryID(value);
    }
  };

  const handProdTable = (SB) => {
    toggleSPT();
    if (SB) {
      setFilterUserProd({ ...getFilterUserProd, ["limit"]: 12 });
    } else {
      setFilterUserProd({ ...getFilterUserProd, ["limit"]: 30 });
    }
  };

  const filterCategory = () => (
    <div className="row mt-4 mb-4 justify-content-center">
      <div className="col col-12 col-md-10 col-lg-8 col-xl-6">
        <SearchBar
          infoSource={infoSource}
          getFilterUserProd={getFilterUserProd}
          setFilterUserProd={setFilterUserProd}
          setSowFilterOurTeam={setSowFilterOurTeam}
          showProdTable={settings.SPT}
          handProdTable={handProdTable}
          productShowAll={productShowAll && shopAllProdB[0]}
          Shop={true}

        />
      </div>
    </div>
  );

  const ButtonArray = (index) => {
    if (index === 0) changeView("admin");
    else if (index === 1) changeView("customer");
    else if (index === 2) changeView("orders");
  };

  const shopProductMenu = () => (
    <div className="row mt-4 justify-content-center">
      <div className="col col-12 col-md-10 col-lg-9 col-xl-8 p-0">
        <div className="userproducts-shop-menu-premium">
          <div className="row">
            <div
              className={`col col-12 col-md-3 userproducts-shop-menu-tab ${
                productShowAll ? "userproducts-shop-menu-tab-active" : ""
              }`}
              onClick={ButtonShoAllProduct}
            >
              <p>{infoSource.laguangeElakay("Button", infoSource.languageAPI).allProduct}</p>
            </div>

            <div
              className={`col col-12 col-md-3 userproducts-shop-menu-tab ${
                sellAddProdBoll ? "userproducts-shop-menu-tab-active" : ""
              }`}
              onClick={() => ButtonsellAddProd()}
            >
              <p>{infoSource.language(infoSource, "menuList", "sell")|| elakayAutoText("h_2af80dd16ddcb0", "Sell Center")}</p>
            </div>

            <div
              className={`col col-12 col-md-3 userproducts-shop-menu-tab ${
                productShowDealTrue || productShowDealFalse ? "userproducts-shop-menu-tab-active" : ""
              }`}
              onClick={ButtonDealProduct}
            >
              <p>{infoSource.language(infoSource, "title", "deal")}</p>
            </div>

            <div
              className={`col col-12 col-md-3 userproducts-shop-menu-tab ${
                userAddPubShow ? "userproducts-shop-menu-tab-active" : ""
              }`}
              onClick={ButtonNotUserPub}
            >
              <p>{infoSource.laguangeElakay("Button", infoSource.languageAPI).creataPub}</p>
            </div>

            {/* <div className="col col-12 col-md-2 userproducts-shop-menu-tab userproducts-shop-menu-tab-pagebuilder">
              <Link to="/pageBuilder?mode=store" style={{ textDecoration: "none", color: "inherit" }}>
                <p>{elakayAutoText("h_0e15b55d222eaf", "🎨 Page & Content")}</p>
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );

  let propsFIlter = {
            getCategoriesUser,
            getFilterUserProd,
            setFilterUserProd,
            handleFilters,
            setMyFilters,
            myFilters,
            setSowFilterOurTeam,
            infoFil: { token, DealProduct },
            loadProductsByArrival,
            showProdTable: settings.SPT
   }

  const filterOurTeam = () => {
    return (
      <Modal
        size="md"
        show={showFilterOurTeam}
        onHide={() => setSowFilterOurTeam(false)}
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            <h2>{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).userProduct.t002}</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FilterUserProduct
            infoSource={infoSource}
           {...propsFIlter}
          />
        </Modal.Body>
      </Modal>
    );
  };

  const shopDealMenu = () => (
    <div className="row mt-2 mb-2 justify-content-center">
      <div className="col col-8 col-md-7 col-lg-6 p-0">
        <div className="userproducts-shop-submenu-premium">
          <div className="row">
            <div
              className={`col col-12 col-md-6 userproducts-shop-submenu-tab ${
                productShowDealTrue ? "userproducts-shop-submenu-tab-active" : ""
              }`}
              onClick={ButtonDealProduct}
            >
              <p>{infoSource.language(infoSource, "title", "inDeal")}</p>
            </div>

            <div
              className={`col col-12 col-md-6 userproducts-shop-submenu-tab ${
                productShowDealFalse ? "userproducts-shop-submenu-tab-active" : ""
              }`}
              onClick={ButtonNotDealProduct}
            >
              <p>{infoSource.language(infoSource, "title", "outDeal")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const shopPubMenu = () => (
    <div className="row mt-2 mb-2 justify-content-center">
      <div className="col col-8 col-md-7 col-lg-6 p-0">
        <div className="userproducts-shop-submenu-premium">
          <div className="row">
            <div
              className={`col col-12 col-md-6 userproducts-shop-submenu-tab ${
                shopPubB ? "userproducts-shop-submenu-tab-active" : ""
              }`}
              onClick={() => changeView("global")}
            >
              <p>{infoSource.language(infoSource, "title", "gloPub")}</p>
            </div>

            <div
              className={`col col-12 col-md-6 userproducts-shop-submenu-tab ${
                !shopPubB ? "userproducts-shop-submenu-tab-active" : ""
              }`}
              onClick={() => changeView("shop")}
            >
              <p>{infoSource.language(infoSource, "title", "myShopPub")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const shopViewPage = () => (
    <div className="row mt-2 mb-2 justify-content-center">
      <div className="col col-9 col-md-8 col-lg-7 p-0">
        <div className="userproducts-shop-submenu-premium">
          <div className="row">
            <div
              className={`col col-12 col-md-4 userproducts-shop-submenu-tab ${
                shopAllProdB[0] ? "userproducts-shop-submenu-tab-active" : ""
              }`}
              onClick={() => ButtonArray(0)}
            >
              <p>{infoSource.language(infoSource, "Button", "adminView")}</p>
            </div>

            <div
              className={`col col-12 col-md-4 userproducts-shop-submenu-tab ${
                shopAllProdB[1] ? "userproducts-shop-submenu-tab-active" : ""
              }`}
              onClick={() => ButtonArray(1)}
            >
              <p>{infoSource.language(infoSource, "Button", "customerView")}</p>
            </div>

            <div
              className={`col col-12 col-md-4 userproducts-shop-submenu-tab ${
                shopAllProdB[2] ? "userproducts-shop-submenu-tab-active" : ""
              }`}
              onClick={() => ButtonArray(2)}
            >
              <p>{infoSource.language(infoSource, "Button", "order")}</p>
            </div>

          {/* {Family(userInfo.email) && <div className="col col-12 col-md-2 userproducts-shop-submenu-tab userproducts-shop-menu-tab-pagebuilder">
              <Link to="/pageBuilder?mode=store" style={{ textDecoration: "none", color: "inherit" }}>
                <p>{elakayAutoText("h_0e15b55d222eaf", "🎨 Page & Content")}</p>
              </Link>
            </div>} */}
          </div>
        </div>
      </div>
    </div>
  );

  const CustomerVIewShop = () => {
    return (
      <>
        <ShopUserView
          key={activeSellerShopKey}
          shopId={activeSellerShopId}
          token={token}
          setLoading={setLoading}
          infoSource={infoSource}
          prices={prices}
          myShop={true}
          showShopSwitcher={false}
          setFilterShop={setFilterShop}
          setCalFilShop={setCalFilShop}
          myFilters={myFilters}
          userID={userInfo._id}
        />
      </>
    );
  };

  // Volontairement PAS "MyShop" : cette valeur ferait aussi apparaitre le
  // panneau FilterUserProduct dupliqué de SideDrawer1.js (le tiroir de droite
  // ouvert par l'icône filtre de la sous-navigation) en plus du modal
  // "Filtres" propre à cette page (filterOurTeam() ci-dessus), les deux
  // pilotant le même state myFilters -- d'où le doublon visible à l'écran
  // quand on coche une catégorie dans le modal.
  const layoutInpage = elakayAutoText("h_7f4111c7695422", "MyShopModal");

  return (
    <Layout
      infoSource={infoSource}
      className="container-fluid"
      loadProductsByArrival={loadProductsByArrival}
      SliderPunShow={false}
      ShowSideDeal={showSideDeal}
      myFilters={myFilters}
      getFilterUserProd={getFilterUserProd}
      setShowSideDeal={setShowSideDeal}
      productaddToDeal={productaddToDeal}
      loading={loading}
      skip={skip}
      limit={limit}
      handleFilters={handleFilters}
      DealProduct={DealProduct}
      setFilterShop={setFilterShop}
      getCalFilShop={getCalFilShop}
      setMyFilters={setMyFilters}
      filterShop={filterShop}
      userShop={true}
      inpage={!showFilterOurTeam?"MyShop":undefined}
      propsFIlter={propsFIlter}
    {...infoSource?.allSettings?.layout}
            enableBodyParticles={false}
            enableFloatingSquares={false}
            enableContentFadeIn={false}

            enableFooterAnimations={false}
            enableSectionAnimations={false}
            enableItemAnimations={false}
            enableHoverAnimations={false}
            enableButtonAnimations={false}
            enableIconAnimations={false}
            enableBackgroundGrid={false}
            enableGradientOverlay={false}
            enableShineEffect={false}
            enableScrollAnimations={false}
            enableStaggeredAnimations={false}
            enableFloatingParticles={false}
            enableRippleEffect={false}
            enableTitleAnimations={false}
            enableLinkAnimations={false}
            enableDividerAnimations={false}
            enableCopyrightAnimations={false} 
    >
      <div 
      ref={divCatProduct} 
      style={infoSource.styleNav} 
      className="userproducts-userproducts-premium-container"
      >
        {/* One selector for the whole workspace.  Previously it only existed
            inside Customer View, so Admin/Orders could be scoped to an empty
            secondary shop with no visible way to understand or change it. */}
        <ShopBar type="seller" />
        {shopProductMenu()}
        {userAddPubShow && shopPubMenu()}
        {productShowAll && shopViewPage()}
        {(productShowDealTrue || productShowDealFalse) && shopDealMenu()}

        {productShowAll && shopAllProdB[0] && showAllProduct()}
        {productShowAll && shopAllProdB[1] && CustomerVIewShop()}
        {productShowAll && shopAllProdB[2] && <Orders key={activeSellerShopKey} infoSource={infoSource} />}

        {showDealProduct()}
        {showNotDealProduct()}
        {showTrashProduct()}

        {showUserPubPage()}
        {showUserPubShop()}
        {printListeShop()}

        {sellerAddProd()}
        {filterOurTeam()}

        {(productShowDealTrue || productShowDealFalse) && shopDealMenu()}
        {productShowAll && shopViewPage()}
        {userAddPubShow && shopPubMenu()}
        {shopProductMenu()}
      </div>
    </Layout>
  );
};

export default UserProducts;
